import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getContactDecoratorStyles } from './styles/contact';

import locationIcon from './assets/contact-address-icon.svg';
import phoneIcon from './assets/contact-phone-icon.svg';

export const ContactDecorator = ({
  data: {
    phone,
    address,
  },
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getContactDecoratorStyles({ styleOverrides }));

  return (
    <div className={classnames('address-and-phone-container', classes.container)}>
      {
        address &&
        <div className={classnames('address-section', classes.section)}>
          <img className={classnames('address-icon', classes.icon)} alt="" src={locationIcon} />
          <span className={classnames('address-label', classes.addressLabel)}>{address}</span>
        </div>
      }
      { phone &&
        <div className={classnames('phone-section', classes.section)}>
          {
            !address &&
            <img className={classnames('phone-icon', classes.icon)} alt="" src={phoneIcon} />
          }
          <div className={classnames('phone-label', classes.phoneLabel)}>{phone}</div>
        </div>
      }
    </div>
  );
};

ContactDecorator.propTypes = {
  data: PropTypes.shape({
    phone: PropTypes.string,
    address: PropTypes.string,
  }),
  styleOverrides: PropTypes.shape({}),
};

ContactDecorator.defaultProps = {
  data: {},
  styleOverrides: {},
};
